import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ambassador-tree")({
  component: lazyRouteComponent(() => import("./-pages/admin.ambassador-tree")),
  head: () => ({
    meta: [
      { title: "شجرة السفير · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
